export function downloadDOM(url: string) {
  const element = document.createElement('a');
  element.setAttribute('download', '');
  element.setAttribute('target', '_blank');
  element.setAttribute('href', url);
  element.setAttribute('style', 'display: none;');
  document.body.appendChild(element);
  element.click();
  element.remove();
}

export function openInNewTab(url: string) {
  const element = document.createElement('a');
  // element.setAttribute('download', '');
  element.setAttribute('target', '_blank');
  element.setAttribute('href', url);
  element.setAttribute('style', 'display: none;');
  document.body.appendChild(element);
  element.click();
  element.remove();
}
